export interface UserDto {
  userId?: number;
  lastName: string;
  firstName: string;
  email: string;
  username: string;
  active?: boolean;
  dateStart?: string;
  dateEnd?: string;
}

export const userKeyId = "userId";

export const userFields = [
  { name: "lastName", label: "Επώνυμο", type: "text", required: true },
  { name: "firstName", label: "Όνομα", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "username", label: "Όνομα Χρήστη", type: "text", required: true },
] as const;

export const userFilters = userFields.filter((f) =>
  ["lastName", "email", "username"].includes(f.name),
);

export const userFormData: string[] = [
  "lastName",
  "firstName",
  "email",
  "username",
];
